import { create } from 'zustand';

type ArtworkStepperStore = {
  imageFile: File | null;
  activeStep: number;
  setActiveStep: (step: number) => void;
  setImageFile: (file: File) => void;
  resetStore: () => void;
};

/**
 * UI state for the multi-step artwork creation dialog.
 *
 * Holds only transient wizard state (which step we're on, the uploaded
 * image file mid-flow). The freshly created artwork is no longer stored
 * here — as soon as the API returns, the artwork id goes straight into
 * the basket (see useBasketStore) and the stepper dialog closes.
 */
export const useArtworkStepperStore = create<ArtworkStepperStore>()((set) => ({
  imageFile: null,
  activeStep: 0,
  setImageFile: (file: File) => {
    set({ imageFile: file });
  },
  setActiveStep: (step) => {
    set({ activeStep: step });
  },
  resetStore: () => {
    set(() => ({
      activeStep: 0,
      imageFile: null,
    }));
  },
}));
